export default "__VITE_ASSET__DEmT5hzK__"